<script lang="ts">
  import { Button } from "sveltestrap";
  import data from "../../../../Data/Users/Users.json"
  import { SocialNetworks } from "../../../../utils/Constant/Constant";
</script>

<div class="social-network theme-form">
  <span class="f-w-600">{SocialNetworks}</span>
  {#each data.socialnetworkdata as userItem}
    <Button class="social-btn {userItem.class} text-center">
      <i class="fa fa-{userItem.icon} m-r-5" />{userItem.title}
    </Button>
  {/each}
</div>
